<template>
  <div class="container-fluid">
    <div class="btn-toolbar">
      <h4>Fehler- und Warnmeldungen</h4>
      <button @click="reload" class="ml-3 btn btn-primary"><font-awesome-icon icon="redo"/></button>
    </div>
    <div v-for="(val,key) in messages" :key="key" class="container-fluid">
      <div class="row">
        <h5>{{ key }}</h5>
      </div>
      <div v-for="(msg,idx) in val" :key="idx" class="row">
        <div class="alert" v-bind:class="msgClass(msg)">
          {{msg.time }} - {{ msg.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'

export default {
  name: 'SysMsgView',
  data() {
    return {
      messages: {},
    }
  },
  created: function() {
    this.reload();
  },
  methods: {
    msgClass(msg) {
      if (msg.level == 'WARN') return 'alert-warning';
      if (msg.level == 'ERROR') return 'alert-danger';
      return '';
    },
    reload: function() {
      var self = this;
      config.get(this,config.baseUrl + 'rest/log/errors?logger=all','Meldungen laden',function(data) {
        console.log(data);
        self.messages = data;
      });
    }
  }
}
</script>
